import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useGetAdspaceListQuery } from 'entities/Adspace';
import { useGetAppConfigQuery } from 'shared/api';
import { META_REQUEST_LIMIT } from 'shared/consts';
import { EMainRoutes } from 'shared/typings';

export const useRedirectToCreateAdspace = () => {
	const [searchParams] = useSearchParams();
	const createdAdspaceId = searchParams.get('adspaceId') || '';
	const { data: appConfig } = useGetAppConfigQuery();

	useEffect(() => {
		if (createdAdspaceId && appConfig?.user?.user_id) {
			localStorage.setItem(`sourceWasCreated_${appConfig.user.user_id}`, 'true');
		}
	}, [createdAdspaceId, appConfig?.user?.user_id]);

	const { data: adspaceList } = useGetAdspaceListQuery(`limit=${META_REQUEST_LIMIT}`);

	const adspacesCount = adspaceList?.results?.length;
	const createAdspaceUrl = appConfig?.mitgo_create_adspace_url;
	const callbackUrl = new URL(`${window.location.origin}/${EMainRoutes.SOURCES}/`);
	callbackUrl.searchParams.append('connectSourceModal', 'true');
	const createAdspaceFullUrl = `${createAdspaceUrl}&callback_url=${encodeURIComponent(callbackUrl.href)}`;

	useEffect(() => {
		if (
			adspacesCount === 0 &&
			createAdspaceUrl &&
			!createdAdspaceId &&
			!localStorage.getItem(`sourceWasCreated_${appConfig?.user?.user_id || ''}`)
		) {
			window.location.replace(createAdspaceFullUrl);
		}
	}, [adspacesCount, createAdspaceUrl, createAdspaceFullUrl, createdAdspaceId, appConfig?.user?.user_id]);

	return { createAdspaceUrl, createAdspaceFullUrl };
};
